var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 73,
    viewBox: "0 0 109 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185148_53122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.693 62.0375H9.98336C9.30296 62.0375 8.75 61.476 8.75 60.7851V1.25237C8.75 0.561484 9.30296 0 9.98336 0H51.693C52.3734 0 52.9263 0.561484 52.9263 1.25237V60.7851C52.9263 61.476 52.3734 62.0375 51.693 62.0375ZM9.98336 0.0548325C9.3332 0.0548325 8.804 0.592191 8.804 1.25237V60.7851C8.804 61.4453 9.3332 61.9826 9.98336 61.9826H51.693C52.3431 61.9826 52.8723 61.4453 52.8723 60.7851V1.25237C52.8723 0.592191 52.3431 0.0548325 51.693 0.0548325H9.98336Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4156 62.0946H56.706C56.0256 62.0946 55.4727 61.5331 55.4727 60.8422V1.3095C55.4727 0.618613 56.0256 0.0571289 56.706 0.0571289H98.4156C99.096 0.0571289 99.649 0.618613 99.649 1.3095V60.8422C99.649 61.5331 99.096 62.0946 98.4156 62.0946ZM56.706 0.111961C56.0559 0.111961 55.5267 0.64932 55.5267 1.3095V60.8422C55.5267 61.5024 56.0559 62.0398 56.706 62.0398H98.4156C99.0658 62.0398 99.595 61.5024 99.595 60.8422V1.3095C99.595 0.64932 99.0658 0.111961 98.4156 0.111961H56.706Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 71.8196H0.5V71.8744H108.5V71.8196Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8392 20.4086H36.4282C38.9381 20.4086 39.5429 16.8401 37.1734 16.0044C37.1432 15.9935 37.1129 15.9825 37.0827 15.9737C39.7049 13.7563 33.9507 9.07799 27.704 15.5548C28.19 13.3966 22.6366 14.1752 20.9388 17.1208C20.3362 15.1863 15.0377 18.5465 16.8413 20.4108L16.8392 20.4086Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.236 11.5148H80.9821C80.9821 11.5148 83.7361 10.4621 83.3797 7.67219C83.0233 4.88231 78.8653 7.20721 78.8653 7.20721C78.8653 7.20721 80.1267 3.3141 76.0983 4.41952C72.0721 5.52275 71.6789 9.38296 71.6789 9.38296C71.6789 9.38296 66.3891 8.44642 69.236 11.517V11.5148Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0262 19.3624H87.7806C87.7806 19.3624 89.5994 18.6671 89.3639 16.8247C89.1285 14.9824 86.3831 16.5177 86.3831 16.5177C86.3831 16.5177 87.2147 13.9471 84.5558 14.6775C81.8968 15.4057 81.6376 17.9543 81.6376 17.9543C81.6376 17.9543 78.1449 17.3358 80.0241 19.3624H80.0262Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5376 59.2761L78.516 56.9468V56.8064L78.4944 54.7316V54.5978L78.475 52.6238V52.4944L78.4556 50.6148V50.4941L78.4361 48.7V48.586L78.4188 46.8708V46.7611L78.4037 45.1227V45.0175L78.3908 43.662C78.3238 43.7037 78.2504 43.7388 78.1683 43.7673L78.1769 44.9122L76.747 44.9188L77.8983 43.8462C77.7881 43.8682 77.665 43.8857 77.5397 43.8901L76.5893 44.7718L76.6066 43.7388C76.5224 43.7015 76.4446 43.6576 76.3841 43.6072L76.3604 45.0284V45.1337L76.3323 46.7721V46.884L76.2999 48.5947V48.711L76.2696 50.5029V50.6235L76.2351 52.5032V52.6326L76.2005 54.6022V54.7382L76.1616 56.8108V56.9512L76.1206 59.2783L75.9219 69.3258L78.6802 69.3587L78.5441 59.2783L78.5376 59.2761ZM78.2504 58.8396L76.5893 57.017H78.2396L78.2504 58.8396ZM78.2244 56.7999H76.5807L78.2136 55.0606L78.2266 56.7999H78.2244ZM78.2417 54.2403L76.6606 52.5953L78.2309 52.5909L78.2417 54.2403ZM78.2223 52.3694L76.6563 52.3738L78.2136 50.7902L78.2223 52.3694ZM78.2093 50.1915L76.7016 48.6978L78.1985 48.6934L78.2072 50.1915H78.2093ZM78.1985 48.4631L76.7038 48.4697L78.1877 47.0265L78.1985 48.4631ZM78.1726 45.1403L78.1812 46.5067L76.7405 45.1469L78.1726 45.1403ZM76.5483 45.4517L77.989 46.816L76.5288 46.8204L76.5483 45.4517ZM76.5245 47.0528L77.9847 47.0463L76.5029 48.4829L76.5224 47.055L76.5245 47.0528ZM76.4943 49.0488L78.002 50.5446L76.477 50.549L76.4964 49.0488H76.4943ZM76.4748 50.7749L78.0063 50.7705L76.4532 52.3453L76.4748 50.7749ZM76.4446 52.9528L78.0257 54.6044H76.4208L76.4446 52.9528ZM76.4273 54.8259H78.0387L76.4057 56.5564L76.4273 54.8259ZM76.4187 57.1201L78.0797 58.9515H76.3928L76.4187 57.1201Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3717 43.4252H78.2593L78.1816 43.355L77.5228 43.9669C77.6502 43.9625 77.7712 43.945 77.8813 43.923L78.1492 43.673V43.8441C78.2334 43.8178 78.3069 43.7805 78.3738 43.7388V43.4252H78.3717ZM76.3715 43.4383L76.3672 43.684C76.4277 43.7344 76.5054 43.7783 76.5897 43.8156L76.594 43.4383H76.3715Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6956 43.2431C78.7151 43.3593 78.6719 43.4756 78.579 43.5764L78.5012 43.6488C78.4645 43.6795 78.4192 43.7124 78.3716 43.7387C78.3047 43.7804 78.2312 43.8155 78.1492 43.844C78.0649 43.8791 77.9764 43.9054 77.8792 43.9252C77.769 43.9471 77.648 43.9647 77.5206 43.969C77.5055 43.9712 77.4882 43.9712 77.4752 43.9712H77.3586C77.0605 43.969 76.7927 43.9098 76.5875 43.8155C76.5032 43.7782 76.4255 43.7344 76.365 43.6839C76.3585 43.6795 76.352 43.6751 76.3456 43.6686L76.2743 43.5984C76.1857 43.5019 76.149 43.39 76.1684 43.2738L76.3326 42.3394L75.8984 42.346L77.4083 41.5674L78.9829 42.2956L78.5401 42.3021L78.6913 43.2409L78.6956 43.2431Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6289 44.4146L85.6872 69.3238H87.4671H97.8135H99.5933L99.6732 44.4146H85.6289Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3438 41.2451L88.3502 46.7985H89.4518H95.8562H96.9578L96.9686 41.2451H88.3438Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3326 46.7985H86.5139L86.5117 45.1338H88.3304L88.3326 46.7985Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8226 45.1338H90.0039V46.7985H91.8226V45.1338Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3109 45.1338H93.4922V46.7985H95.3109V45.1338Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7992 46.7985H96.9805L96.9848 45.1338H98.8035L98.7992 46.7985Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3111 49.8296H86.5356L86.5312 48.2065H88.3089L88.3111 49.8296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7933 48.2065H90.0156V49.8296H91.7933V48.2065Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2816 48.2065H93.5039V49.8296H95.2816V48.2065Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7621 49.8296H96.9844L96.9887 48.2065H98.7664L98.7621 49.8296Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2935 52.7884H86.559L86.5547 51.2048H88.2913L88.2935 52.7884Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7757 51.2048H90.0391V52.7884H91.7757V51.2048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2562 51.2048H93.5195V52.7884H95.2562V51.2048Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8103 42.7168H89.957V44.4144H91.8103V42.7168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3047 42.7168H93.4492V44.4144H95.3047V42.7168Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7345 52.7884H97L97.0022 51.2048H98.7388L98.7345 52.7884Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2898 55.6749H86.5942L86.5898 54.1309H88.2876L88.2898 55.6749Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7659 54.1309H90.0703V55.6771H91.7659V54.1309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2425 55.6749H93.5469L93.549 54.1309H95.2446L95.2425 55.6749Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.719 55.6749H97.0234L97.0278 54.1309H98.7234L98.719 55.6749Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.367 58.921H86.477L86.4727 57.2014H88.3648L88.367 58.921Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8353 58.921H89.9453V57.2014H91.8375L91.8353 58.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3041 58.921H93.4141V57.2014H95.3062L95.3041 58.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7728 58.921H96.8828L96.8871 57.2014H98.7771L98.7728 58.921Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3746 61.6647H86.5278L86.5234 59.9846H88.3724L88.3746 61.6647Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8429 59.9846H89.9961V61.6647H91.8429V59.9846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3155 59.9846H93.4688V61.6647H95.3155V59.9846Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7804 61.6647H96.9336L96.9379 59.9846H98.7847L98.7804 61.6647Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3388 64.7485H86.5373L86.5352 63.1145H88.3366L88.3388 64.7485Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8014 63.1145H90V64.7507H91.8014V63.1145Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2624 63.1145H93.4609V64.7507H95.2624V63.1145Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7212 64.7485H96.9219L96.924 63.1145H98.7255L98.7212 64.7485Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3385 67.556H86.5803L86.5781 65.9614H88.3364L88.3385 67.556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.717 67.556H96.9609L96.9631 65.9614H98.7213L98.717 67.556Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2722 65.9614H90.0234L90.0342 66.3606H90.179L90.1811 69.3238H90.706L90.7038 66.3606H94.6005L94.5962 69.3238H95.121L95.1254 66.3606H95.283L95.2722 65.9614Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6727 69.3237H90.7287L90.7266 66.3606H92.6749L92.6727 69.3237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5712 69.3237H92.625L92.6272 66.3606H94.5755L94.5712 69.3237Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6485 52.3386L85.6874 69.3235H83.4561H70.4831H68.2497L68.0898 52.3386H85.6485Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3112 56.1134H84.4884L84.482 54.1306H82.3047L82.3112 56.1134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9678 56.1134H80.1451L80.1365 54.1306H77.957L77.9678 56.1134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 56.1134H75.8018L75.7888 54.1306H73.6094L73.6245 56.1134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.279 56.1134H71.4563L71.439 54.1306H69.2617L69.279 56.1134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2274 59.9844H84.5731L84.5667 57.8503H82.2188L82.2274 59.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8958 59.9844H80.2415L80.2307 57.8503H77.8828L77.8958 59.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5581 59.9844H75.9038L75.8909 57.8503H73.543L73.5581 59.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2226 59.9844H71.5683L71.551 57.8503H69.2031L69.2226 59.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2899 63.5243H84.5665L84.5622 61.4561H82.2812L82.2899 63.5243Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9583 63.5243H80.2349L80.2263 61.4561H77.9453L77.9583 63.5243Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 63.5243H75.9033L75.8903 61.4561H73.6094L73.6245 63.5243Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2968 63.5243H71.5734L71.5583 61.4561H69.2773L69.2968 63.5243Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3407 67.1587H84.5482L84.5439 65.1541H82.332L82.3407 67.1587Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.361 67.1587H71.5707L71.5534 65.1541H69.3438L69.361 67.1587Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5273 65.1541H80.3573L80.3594 65.7594H79.9231L79.9404 69.3235H79.3075L79.2902 65.7594H74.603L74.6268 69.3235H73.9961L73.9701 65.7594H73.5317L73.5273 65.1541Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9825 69.3236H79.3218L79.3045 65.7595H76.9609L76.9825 69.3236Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6097 69.3236H76.949L76.9295 65.7595H74.5859L74.6097 69.3236Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3508 37.7994V36.9989C33.3508 36.876 33.1629 36.876 33.1629 36.9989V37.8762C33.1629 37.931 33.2061 37.9661 33.2558 37.9705C33.5517 38.0012 33.7699 38.3762 33.5236 38.6241C33.2774 38.8719 32.9102 38.6745 32.88 38.3521C32.867 38.2315 32.6791 38.2293 32.692 38.3521C32.7396 38.8259 33.286 39.1395 33.6576 38.7579C34.0032 38.4026 33.7656 37.9003 33.3508 37.795V37.7994Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5049 32.0594V33.7921L17.7099 31.9695L17.6214 32.0594H17.4961V48.5091H19.7555V32.0594H19.5049ZM17.7467 44.6073L19.3278 46.2128H17.7467V44.6073ZM17.7467 40.5277L19.3278 42.1332H17.7467V40.5277ZM17.7467 36.4482L19.3278 38.0537H17.7467V36.4482ZM17.7467 32.3687L19.3278 33.9742H17.7467V32.3687ZM19.3278 34.2286L17.7467 35.8341V34.2286H19.3278ZM19.5049 34.4084V36.0139H17.9238L19.5049 34.4084ZM19.3278 38.3081L17.7467 39.9136V38.3081H19.3278ZM19.5049 38.488V40.0935H17.9238L19.5049 38.488ZM19.3278 42.3877L17.7467 43.9931V42.3877H19.3278ZM19.5049 42.5675V44.173H17.9238L19.5049 42.5675ZM19.3278 46.4672L17.7467 48.0727V46.4672H19.3278ZM17.9238 48.2525L19.5049 46.647V48.2525H17.9238ZM19.5049 46.0329L17.9238 44.4274H19.5049V46.0329ZM19.5049 41.9534L17.9238 40.3479H19.5049V41.9534ZM19.5049 37.8738L17.9238 36.2683H19.5049V37.8738Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 26.6421V29.829H18.0006V28.6051L19.2944 29.9189L19.383 29.829H19.5082V26.6421H17.75ZM19.0806 26.8965L18.0006 27.9932V26.8965H19.0806ZM19.2577 29.5219L18.1777 28.4252H19.2577V29.5219ZM18.1777 28.1708L19.2577 27.0742V28.1708H18.1777Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6226 32.0596H10.6094V35.1192H13.6226V32.0596Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2982 36.4746H33.1298V30.59L19.0962 25.8657H18.1696L10.655 30.601L10.5664 30.4584L18.1221 25.6946H19.1243L19.1373 25.699L33.2982 30.4672V36.4746Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5811 32.1911H31.7539L33.5165 30.4014H10.4844V32.1867H31.5811V32.1911ZM31.8317 30.6558H32.9117L31.8317 31.7524V30.6558ZM10.7349 31.9323V30.8356L11.8149 31.9323H10.7349ZM11.9921 31.7524L10.9121 30.6558H11.9921V31.7524ZM12.2426 30.6558H13.3226L12.2426 31.7524V30.6558ZM13.4997 31.9323H12.4197L13.4997 30.8356V31.9323ZM13.7503 31.9323V30.8356L14.8303 31.9323H13.7503ZM15.0074 31.7524L13.9274 30.6558H15.0074V31.7524ZM15.258 30.6558H16.338L15.258 31.7524V30.6558ZM16.5151 31.9323H15.4351L16.5151 30.8356V31.9323ZM16.7657 31.9323V30.8356L17.8457 31.9323H16.7657ZM18.0228 31.7524L16.9428 30.6558H18.0228V31.7524ZM18.2733 30.6558H19.3533L18.2733 31.7524V30.6558ZM19.5305 31.9323H18.4505L19.5305 30.8356V31.9323ZM19.781 31.9323V30.8356L20.861 31.9323H19.781ZM21.0381 31.7524L19.9581 30.6558H21.0381V31.7524ZM21.2887 30.6558H22.3687L21.2887 31.7524V30.6558ZM22.5458 31.9323H21.4658L22.5458 30.8356V31.9323ZM22.7964 31.9323V30.8356L23.8764 31.9323H22.7964ZM24.0535 31.7524L22.9735 30.6558H24.0535V31.7524ZM24.3041 30.6558H25.3841L24.3041 31.7524V30.6558ZM25.5612 31.9323H24.4812L25.5612 30.8356V31.9323ZM25.8117 31.9323V30.8356L26.8917 31.9323H25.8117ZM27.0689 31.7524L25.9889 30.6558H27.0689V31.7524ZM27.3194 30.6558H28.3994L27.3194 31.7524V30.6558ZM28.5765 31.9323H27.4965L28.5765 30.8356V31.9323ZM28.8271 30.6558H29.9071L28.8271 31.7524V30.6558ZM30.0842 31.9323H29.0042L30.0842 30.8356V31.9323ZM30.3348 31.9323V30.8356L31.4148 31.9323H30.3348ZM30.5119 30.6558H31.5919V31.7524L30.5119 30.6558Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8736 32.7547H16.2383L16.4089 30.7742C16.4543 30.239 16.8949 29.8289 17.4241 29.8289H19.6316C20.15 29.8289 20.5842 30.2237 20.6447 30.7435L20.8736 32.7525V32.7547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8743 30.6514H16.9844V31.555H17.8743V30.6514Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9993 30.6514H18.1094V31.555H18.9993V30.6514Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1282 30.6514H19.2383V31.555H20.1282V30.6514Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2335 26.1529C19.2335 26.4929 18.9613 26.7693 18.6265 26.7693C18.2917 26.7693 18.0195 26.4929 18.0195 26.1529C18.0195 25.813 18.2917 25.5366 18.6265 25.5366C18.9613 25.5366 19.2335 25.813 19.2335 26.1529Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2567 37.5274C32.9694 37.5274 32.7383 37.2927 32.7383 37.001V36.4746H33.7751V37.001C33.7751 37.2927 33.544 37.5274 33.2567 37.5274Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71484 44.4143L9.1166 69.3236H10.8986H21.245H23.0248L22.7592 44.4143H8.71484Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 45.1338L9.64127 48.1649L9.65639 48.9984L9.66935 49.8296H11.4902L11.4773 48.9984L11.4665 48.1649L11.419 45.1338H9.59375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.082 45.1338L13.1274 48.1649L13.1382 48.9984L13.1512 49.8296H14.972L14.9612 48.9984L14.9504 48.1649L14.9072 45.1338H13.082Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5742 45.1338L16.6153 48.1649L16.6261 48.9984L16.6369 49.8296H18.4577L18.4491 48.9984L18.4383 48.1649L18.4016 45.1338H16.5742Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 45.1338L20.101 48.1649L20.1161 49.4524L20.1204 49.8296H21.9434L21.9391 49.4524L21.924 48.1649L21.8916 45.1338H20.0664Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70312 51.2048L9.7528 54.2316L9.76577 55.065L9.77872 55.8941H11.6018L11.591 55.065L11.578 54.2316L11.5326 51.2048H9.70312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 51.2048L13.2268 54.2316L13.2441 55.405L13.2506 55.8941H15.0758L15.0693 55.405L15.0542 54.2316L15.011 51.2048H13.1836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 51.2048L16.7051 54.2316L16.7159 55.065L16.7267 55.8941H18.5519L18.5411 55.065L18.5303 54.2316L18.4936 51.2048H16.6641Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1445 51.2048L20.1813 54.2316L20.1899 55.065L20.2007 55.8941H22.0237L22.0151 55.065L22.0065 54.2316L21.9741 51.2048H20.1445Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80469 57.2012L9.85221 60.217L9.86733 61.0438L9.88029 61.8729H11.7012L11.6882 61.0438L11.6752 60.217L11.6299 57.2012H9.80469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2773 57.2012L13.3205 60.217L13.3313 61.0438L13.3443 61.8729H15.1652L15.1544 61.0438L15.1436 60.217L15.1025 57.2012H13.2773Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 57.2012L16.7889 60.217L16.7997 61.0438L16.8105 61.8729H18.6335L18.6227 61.0438L18.6119 60.217L18.5752 57.2012H16.75Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2227 57.2012L20.2572 60.217L20.2702 61.3597L20.2767 61.8729H22.0975L22.0932 61.3597L22.0803 60.217L22.0479 57.2012H20.2227Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2335 63.1143H20.3328H18.6458H16.8444H15.1553H13.3538H9.86328L9.8892 64.7483H13.3776H15.1769H16.8638H18.6653H20.3522H21.253H22.1537L22.1364 63.1143H21.2335Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6437 65.9612H13.3949L13.3906 66.3604H13.5483L13.5915 69.3235H14.1164L14.0732 66.3604H17.9698L18.0065 69.3235H18.5314L18.4947 66.3604H18.6394L18.6437 65.9612Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0849 69.3235H14.1409L14.0977 66.3604H16.046L16.0849 69.3235Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.985 69.3235H16.0389L16 66.3604H17.9462L17.985 69.3235Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0039 45.8511L36.1615 69.3238H34.4832H24.7351H23.0568L22.7695 45.8511H36.0039Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3298 63.5247H32.0448H35.2524L35.2567 64.277L35.2632 65.0271L35.2826 67.7533H33.6216L33.6 64.9525H31.98H31.3406H30.4075L30.3945 63.5247H31.3298Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0008 63.5247H25.6401H28.6857L28.7009 64.9525H25.5494L25.5818 67.7533H23.9208L23.8905 65.0271L23.8776 63.9414L23.8711 63.5247H25.0008Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3205 66.1611H31.8371L31.8414 66.5603H31.8911L31.9127 69.3239H31.4245L31.4008 66.5603H27.7677L27.7957 69.3239H27.3076L27.2773 66.5603H27.3249L27.3205 66.1611Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5923 69.3239H31.4067L31.383 66.5603H29.5664L29.5923 69.3239Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8171 69.3239H29.6315L29.6056 66.5603H27.7891L27.8171 69.3239Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1562 46.7986H35.1912L35.2214 51.2049H30.1973L30.1562 46.7986Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6289 46.7986H28.6639L28.7071 51.2049H23.6807L23.6289 46.7986Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2969 52.3389H35.1158L35.1482 56.55H30.3336L30.2969 52.3389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7812 52.3389H28.6002L28.6434 56.55H23.8288L23.7812 52.3389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3477 58.0657H35.1947L35.2249 62.2878H30.3844L30.3477 58.0657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8477 58.0657H28.6947L28.7357 62.2878H23.8952L23.8477 58.0657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2383 6.50757L36.044 7.56474H72.9497L73.7619 6.50757H35.2383Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2383 6.50757L36.044 7.56474H72.9497L73.7619 6.50757H35.2383Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.9587 5.14331H35.9688V71.7275H72.9587V5.14331Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9587 5.14331H35.9688V71.7275H72.9587V5.14331Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4676 6.78397C37.5108 7.21605 37.2127 7.56479 36.8045 7.56479C36.3963 7.56479 36.0269 7.21605 35.9815 6.78397C35.934 6.3497 36.2321 5.99438 36.6425 5.99438C37.0529 5.99438 37.4244 6.34751 37.4655 6.78397H37.4676Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8301 6.78397C38.869 7.21605 38.5687 7.56479 38.1605 7.56479C37.7522 7.56479 37.3872 7.21605 37.344 6.78397C37.3008 6.3497 37.5989 5.99438 38.0114 5.99438C38.424 5.99438 38.789 6.34751 38.8301 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1904 6.78397C40.2272 7.21605 39.9248 7.56479 39.5165 7.56479C39.1083 7.56479 38.7454 7.21605 38.7065 6.78397C38.6676 6.3497 38.9679 5.99438 39.3804 5.99438C39.793 5.99438 40.1559 6.34751 40.1926 6.78397H40.1904Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5516 6.78397C41.584 7.21605 41.2794 7.56479 40.8712 7.56479C40.4629 7.56479 40.1022 7.21605 40.0655 6.78397C40.0288 6.3497 40.3333 5.99438 40.7459 5.99438C41.1585 5.99438 41.5192 6.34751 41.5516 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9142 6.78397C42.9423 7.21605 42.6356 7.56479 42.2273 7.56479C41.8191 7.56479 41.4605 7.21605 41.4281 6.78397C41.3957 6.3497 41.7024 5.99438 42.115 5.99438C42.5276 5.99438 42.8861 6.34751 42.9142 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2772 6.78397C44.3031 7.21605 43.9921 7.56479 43.5838 7.56479C43.1756 7.56479 42.8213 7.21605 42.7911 6.78397C42.7609 6.3497 43.0719 5.99438 43.4845 5.99438C43.897 5.99438 44.2513 6.34751 44.2772 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6399 6.78397C45.6615 7.21605 45.3483 7.56479 44.9401 7.56479C44.5318 7.56479 44.1798 7.21605 44.1538 6.78397C44.1279 6.3497 44.4411 5.99438 44.8537 5.99438C45.2662 5.99438 45.6183 6.34751 45.6399 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9988 6.78397C47.0183 7.21605 46.7008 7.56479 46.2925 7.56479C45.8843 7.56479 45.5344 7.21605 45.5128 6.78397C45.4912 6.3497 45.8065 5.99438 46.2191 5.99438C46.6316 5.99438 46.9816 6.34751 46.9988 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3619 6.78397C48.377 7.21605 48.0595 7.56479 47.6491 7.56479C47.2387 7.56479 46.8931 7.21605 46.8758 6.78397C46.8564 6.3497 47.1761 5.99438 47.5865 5.99438C47.9969 5.99438 48.3446 6.34751 48.3619 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7249 6.78397C49.7378 7.21605 49.416 7.56479 49.0078 7.56479C48.5995 7.56479 48.2561 7.21605 48.2388 6.78397C48.2237 6.3497 48.5434 5.99438 48.9559 5.99438C49.3685 5.99438 49.7119 6.34751 49.7249 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0841 6.78397C51.0928 7.21605 50.7688 7.56479 50.3605 7.56479C49.9523 7.56479 49.611 7.21605 49.598 6.78397C49.5851 6.3497 49.9091 5.99438 50.3216 5.99438C50.7342 5.99438 51.0755 6.34751 51.0841 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4433 6.78397C52.4476 7.21605 52.1214 7.56479 51.7132 7.56479C51.305 7.56479 50.9658 7.21605 50.9572 6.78397C50.9486 6.3497 51.2747 5.99438 51.6873 5.99438C52.0998 5.99438 52.439 6.34751 52.4433 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8065 6.78397C53.8065 7.21605 53.4782 7.56479 53.0699 7.56479C52.6617 7.56479 52.3247 7.21605 52.3204 6.78397C52.3139 6.3497 52.6444 5.99438 53.057 5.99438C53.4695 5.99438 53.8043 6.34751 53.8065 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1697 6.78397C55.1697 7.21605 54.8349 7.56479 54.4266 7.56479C54.0184 7.56479 53.6858 7.21605 53.6836 6.78397C53.6814 6.3497 54.0141 5.99438 54.4266 5.99438C54.8392 5.99438 55.1718 6.34751 55.1697 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5291 6.78397C56.5247 7.21605 56.1899 7.56479 55.7795 7.56479C55.3691 7.56479 55.0408 7.21605 55.043 6.78397C55.043 6.3497 55.3799 5.99438 55.7925 5.99438C56.2051 5.99438 56.5355 6.34751 56.5291 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8924 6.78397C57.8837 7.21605 57.5468 7.56479 57.1385 7.56479C56.7303 7.56479 56.402 7.21605 56.4063 6.78397C56.4106 6.3497 56.7497 5.99438 57.1601 5.99438C57.5705 5.99438 57.8989 6.34751 57.8902 6.78397H57.8924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2518 6.78397C59.241 7.21605 58.8997 7.56479 58.4915 7.56479C58.0832 7.56479 57.7592 7.21605 57.7657 6.78397C57.7744 6.3497 58.1135 5.99438 58.526 5.99438C58.9386 5.99438 59.2626 6.34751 59.2518 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6153 6.78397C60.6001 7.21605 60.2567 7.56479 59.8484 7.56479C59.4402 7.56479 59.1184 7.21605 59.1292 6.78397C59.14 6.3497 59.4834 5.99438 59.896 5.99438C60.3085 5.99438 60.6304 6.34751 60.6153 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9788 6.78397C61.9593 7.21605 61.6137 7.56479 61.2055 7.56479C60.7973 7.56479 60.4776 7.21605 60.4927 6.78397C60.5078 6.3497 60.8534 5.99438 61.266 5.99438C61.6785 5.99438 61.9982 6.34751 61.9788 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3385 6.78397C63.3169 7.21605 62.967 7.56479 62.5587 7.56479C62.1505 7.56479 61.833 7.21605 61.8524 6.78397C61.8697 6.3497 62.2196 5.99438 62.6322 5.99438C63.0447 5.99438 63.3601 6.34751 63.3385 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.702 6.78397C64.6761 7.21605 64.3261 7.56479 63.9157 7.56479C63.5053 7.56479 63.1943 7.21605 63.2159 6.78397C63.2375 6.3497 63.5896 5.99438 64.0021 5.99438C64.4147 5.99438 64.7279 6.34751 64.702 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0616 6.78397C66.0335 7.21605 65.6793 7.56479 65.271 7.56479C64.8628 7.56479 64.5517 7.21605 64.5755 6.78397C64.6014 6.3497 64.9557 5.99438 65.3682 5.99438C65.7808 5.99438 66.0918 6.34751 66.0616 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4214 6.78397C67.389 7.21605 67.0326 7.56479 66.6244 7.56479C66.2162 7.56479 65.9073 7.21605 65.9354 6.78397C65.9634 6.3497 66.322 5.99438 66.7346 5.99438C67.1471 5.99438 67.4538 6.34751 67.4214 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7853 6.78397C68.7507 7.21605 68.39 7.56479 67.9818 7.56479C67.5735 7.56479 67.2668 7.21605 67.2992 6.78397C67.3316 6.3497 67.6923 5.99438 68.1027 5.99438C68.5131 5.99438 68.8199 6.34751 68.7853 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.145 6.78397C70.1061 7.21605 69.7433 7.56479 69.335 7.56479C68.9268 7.56479 68.6244 7.21605 68.6589 6.78397C68.6935 6.3497 69.0564 5.99438 69.4689 5.99438C69.8815 5.99438 70.1839 6.34751 70.145 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.509 6.78397C71.4658 7.21605 71.1008 7.56479 70.6925 7.56479C70.2843 7.56479 69.984 7.21605 70.0229 6.78397C70.0618 6.3497 70.4268 5.99438 70.8394 5.99438C71.252 5.99438 71.5522 6.34751 71.509 6.78397Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8691 6.78397C72.8238 7.21605 72.4544 7.56479 72.0462 7.56479C71.6379 7.56479 71.3399 7.21605 71.3831 6.78397C71.4263 6.3497 71.7935 5.99438 72.206 5.99438C72.6186 5.99438 72.9145 6.34751 72.8691 6.78397Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2383 5.43726H73.7662L73.764 6.50759H35.2404L35.2383 5.43726Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2344 4.36694L36.0379 5.43727H72.9545L73.7666 4.36694H35.2344Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2344 4.36694L36.0379 5.43727H72.9545L73.7666 4.36694H35.2344Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2305 3.29224H73.7692L73.767 4.36695H35.2348L35.2305 3.29224Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0352 4.36694H72.956L72.9539 5.43727H36.0373L36.0352 4.36694Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0352 4.36694H72.956L72.9539 5.43727H36.0373L36.0352 4.36694Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9683 26.5083H35.9805V26.9799H72.9683V26.5083Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9648 49.9109H36.0547V50.3803H72.9648V49.9109Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 9.61328H43.6445V14.6294H48.2173V9.61328Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 9.61328H52.4258V14.6294H56.9985V9.61328Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7837 9.61328H61.2109V14.6294H65.7837V9.61328Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 17.1252H43.6445V22.1413H48.2173V17.1252Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 17.1252H52.4258V22.1413H56.9985V17.1252Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7837 17.1252H61.2109V22.1413H65.7837V17.1252Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 53.5232H43.6445V58.5393H48.2173V53.5232Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 53.5232H52.4258V58.5393H56.9985V53.5232Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7837 53.5232H61.2109V58.5393H65.7837V53.5232Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3188 64.084H38.7461V69.1001H43.3188V64.084Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.186 64.084H65.6133V69.1001H70.186V64.084Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 30.9321H43.6445V35.9482H48.2173V30.9321Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 30.9321H52.4258V35.9482H56.9985V30.9321Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7837 30.9321H61.2109V35.9482H65.7837V30.9321Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 38.4419H43.6445V43.458H48.2173V38.4419Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9985 38.4419H52.4258V43.458H56.9985V38.4419Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7837 38.4419H61.2109V43.458H65.7837V38.4419Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.173 64.6741H53.9056L53.8861 69.6616H49.1406L49.173 64.6741Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8214 64.6741H59.7483L59.5151 69.6616H54.7695L54.8214 64.6741Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.4997 70.6684H48.0128L47.9609 69.6616H60.5473L60.4997 70.6684Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4997 70.6684H48.0128L47.9609 69.6616H60.5473L60.4997 70.6684Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.0044 71.7299H47.5735L47.5195 70.7407H61.0541L61.0044 71.7299Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4493 62.9062H47.0939L47.0312 61.7744H61.5054L61.4493 62.9062Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.0938 62.9062L49.1738 64.674H59.747L61.4491 62.9062H47.0938Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0664 63.733L48.8008 69.6615H49.384L49.1486 63.733C48.8116 63.5532 48.3861 63.5532 48.0664 63.733Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6814 63.7331L59.9621 69.6616H59.3789L59.5992 63.7331C59.9211 63.5138 60.379 63.5138 60.6814 63.7331Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7625 6.25097C82.7625 6.25097 82.581 6.21368 82.311 6.10183C82.0389 5.99435 81.6889 5.81231 81.3261 5.63465C80.9632 5.457 80.6176 5.36707 80.3605 5.34075C80.1035 5.31224 79.9307 5.33417 79.9048 5.27276C79.881 5.22012 80.0322 5.07755 80.3454 5.01834C80.6543 4.95692 81.1014 5.01834 81.5183 5.22231C81.9352 5.42848 82.2246 5.71142 82.432 5.91101C82.6372 6.11499 82.7625 6.25097 82.7625 6.25097Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3488 4.95461C84.3488 4.95461 84.2214 5.00506 84.0227 5.08402C83.8283 5.16517 83.582 5.27703 83.3099 5.39985C82.7634 5.64331 82.299 5.89773 82.2234 5.78807C82.1888 5.73762 82.2601 5.6126 82.4178 5.45907C82.5733 5.30554 82.8196 5.11911 83.1349 4.98093C83.4503 4.84056 83.7786 4.82521 84.0011 4.85811C84.1134 4.87565 84.202 4.89759 84.2624 4.91952C84.3229 4.94145 84.3532 4.95461 84.3532 4.95461H84.3488Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8214 7.218C79.8214 7.218 79.789 7.19826 79.7307 7.16316C79.6745 7.12588 79.5924 7.07763 79.4909 7.02279C79.2879 6.91093 79.0071 6.78153 78.6917 6.66967C78.0567 6.43938 77.4864 6.48982 77.4691 6.39112C77.4605 6.34726 77.5987 6.27269 77.845 6.23759C78.0891 6.2025 78.4411 6.22005 78.7997 6.34506C79.1604 6.47228 79.4347 6.70038 79.5946 6.88681C79.6745 6.98112 79.7328 7.06227 79.7674 7.12368C79.8019 7.1829 79.8192 7.2158 79.8192 7.2158L79.8214 7.218Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4474 5.88237C80.4474 5.88237 80.3567 5.9372 80.2207 6.01616C80.0846 6.09292 79.9075 6.19381 79.7131 6.30567C79.3307 6.51842 79.0348 6.76846 78.9614 6.70047C78.929 6.66976 78.9614 6.56668 79.0586 6.43069C79.1558 6.2969 79.3243 6.13021 79.5511 6.00519C79.7779 5.88017 80.0155 5.84727 80.1796 5.84947C80.3459 5.85166 80.4474 5.88237 80.4474 5.88237Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.294 5.12349C79.294 5.12349 79.078 5.04672 78.7496 4.90635C78.4192 4.76598 77.9764 4.56639 77.4925 4.40409C77.0087 4.24178 76.5486 4.2023 76.2181 4.22424C75.8855 4.24397 75.6738 4.30758 75.6436 4.24836C75.6155 4.20011 75.7883 4.02026 76.162 3.9084C76.5292 3.79216 77.0821 3.78558 77.6329 3.97201C78.1837 4.15844 78.5941 4.47646 78.8684 4.71334C79.1428 4.9546 79.2961 5.12568 79.2961 5.12568L79.294 5.12349Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7541 3.24163C80.7541 3.24163 80.7109 3.25479 80.631 3.27673C80.5532 3.29647 80.4409 3.33156 80.3091 3.37323C80.0435 3.45877 79.6979 3.59475 79.3328 3.76364C78.5941 4.09921 78.1189 4.59709 78.0152 4.51594C77.9677 4.47865 78.0303 4.29661 78.2183 4.05973C78.404 3.82286 78.728 3.54431 79.1449 3.34911C79.5639 3.1539 79.9916 3.11881 80.2854 3.14513C80.4344 3.15829 80.5511 3.18022 80.631 3.20435C80.7087 3.22847 80.7541 3.23944 80.7541 3.23944V3.24163Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7251 11.7891C30.7251 11.7891 30.5437 11.7518 30.2737 11.6399C30.0015 11.5324 29.6516 11.3504 29.2887 11.1727C28.9259 10.9951 28.5803 10.9052 28.3254 10.8788C28.0683 10.8503 27.8955 10.8723 27.8696 10.8108C27.8459 10.7582 27.9971 10.6156 28.3103 10.5564C28.6191 10.495 29.0663 10.5564 29.4831 10.7604C29.9 10.9666 30.1895 11.2495 30.3968 11.4491C30.602 11.6531 30.7273 11.7891 30.7273 11.7891H30.7251Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3098 10.4927C32.3098 10.4927 32.1823 10.5431 31.9836 10.6221C31.7892 10.7033 31.543 10.8151 31.2708 10.9379C30.7243 11.1814 30.2599 11.4358 30.1843 11.3262C30.1498 11.2757 30.2211 11.1507 30.3766 10.9972C30.5321 10.8436 30.7783 10.6572 31.0937 10.519C31.4091 10.3786 31.7374 10.3633 31.9599 10.3962C32.0722 10.4137 32.1607 10.4357 32.2212 10.4576C32.2817 10.4795 32.3119 10.4927 32.3119 10.4927H32.3098Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7823 12.7561C27.7823 12.7561 27.7499 12.7363 27.6916 12.7013C27.6354 12.664 27.5533 12.6157 27.4518 12.5609C27.2488 12.449 26.968 12.3196 26.6526 12.2078C26.0176 11.9775 25.4473 12.0279 25.4301 11.9292C25.4214 11.8853 25.5597 11.8108 25.8059 11.7757C26.05 11.7406 26.4021 11.7581 26.7606 11.8832C27.1214 12.0104 27.3957 12.2385 27.5555 12.4271C27.6354 12.5214 27.6937 12.6026 27.7283 12.664C27.7629 12.7232 27.7802 12.7561 27.7802 12.7561H27.7823Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4045 11.4226C28.4045 11.4226 28.3138 11.4775 28.1777 11.5564C28.0416 11.6332 27.8645 11.7341 27.6701 11.846C27.2878 12.0587 26.9918 12.3087 26.9184 12.2407C26.886 12.21 26.9184 12.107 27.0156 11.971C27.1128 11.8372 27.2813 11.6705 27.5081 11.5455C27.7349 11.4205 27.9725 11.3876 28.1366 11.3897C28.303 11.3919 28.4045 11.4226 28.4045 11.4226Z",
    fill: "#407BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185148_53122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 73,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOrg);
export default __webpack_public_path__ + "static/media/select-org.ad414e7cfb37e1bc6777394c3f66a67f.svg";
export { ForwardRef as ReactComponent };